export const OnDemandActions = Object.freeze({
  ON_DEMAND_GET_ALBUM: 'ON_DEMAND_GET_ALBUM',
  ON_DEMAND_GET_TRACK: 'ON_DEMAND_GET_TRACK',
  ON_DEMAND_GET_ARTIST_ALL_SONGS: 'ON_DEMAND_GET_ARTIST_ALL_SONGS',
  ON_DEMAND_GET_ARTIST_TOP_SONGS: 'ON_DEMAND_GET_ARTIST_TOP_SONGS',
} as const);

export const Explicitness = Object.freeze({
  EXPLICIT: 'EXPLICIT',
  CLEAN: 'CLEAN',
} as const);

export const ReleaseType = Object.freeze({
  SINGLE: 'Single',
  EP: 'EP',
} as const);

export const VARIOUS_ARTISTS_ARTIST_ID = 'AR:3381' as const;
